/**
 * Single source of truth for reading the IAM-CDS session access token.
 *
 * iam-cds's UserManager writes the session under `iam-auth:<iamAppId>:trexpert-portal`
 * in localStorage as `{ accessToken, expiresAt }` (expiresAt in seconds). Both the
 * IAM Magellan transport and the trexpert transport need this token; the role-gating
 * also decodes it — so the read lives here once rather than being copy-pasted.
 */

const SESSION_KEY_PATTERN = /^iam-auth:[^:]+:trexpert-portal$/;

/** A still-valid session access token, or undefined when signed out / expired. */
export const readIamSessionToken = (): string | undefined => {
    if (typeof localStorage === "undefined") {
        return undefined;
    }
    try {
        for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i);
            if (!key || !SESSION_KEY_PATTERN.test(key)) {
                continue;
            }
            const stored = localStorage.getItem(key);
            if (!stored) {
                continue;
            }
            const parsed = JSON.parse(stored) as { accessToken?: string; expiresAt?: number };
            if (!parsed.accessToken || !parsed.expiresAt || parsed.expiresAt * 1000 <= Date.now()) {
                continue;
            }
            return parsed.accessToken;
        }
    } catch {
        return undefined;
    }
    return undefined;
};
